import React from 'react';
import uniqueid from 'lodash';
const jssCache = new WeakMap();
const materialUiPlugin = (element, plugins, app) => {
    if (plugins === null || plugins === void 0 ? void 0 : plugins.find((plugin) => plugin.name === 'material-ui')) {
        try {
            const { create } = require('jss');
            const { jssPreset, StylesProvider, createGenerateClassName } = require('@material-ui/core/styles');
            const seed = uniqueid(`${element.tagName.toLowerCase()}-`);
            const insertionPoint = document.createElement('span');
            insertionPoint.id = 'direflow_material-ui-styles';
            let jss;
            if (jssCache.has(element)) {
                jss = jssCache.get(element);
            }
            else {
                jss = create(Object.assign(Object.assign({}, jssPreset()), { insertionPoint }));
                jssCache.set(element, jss);
            }
            return [
                React.createElement(StylesProvider, { jss: jss, sheetsManager: new Map(), generateClassName: createGenerateClassName({ seed }) }, app),
                insertionPoint,
            ];
        }
        catch (err) {
            console.error('Could not load Material-UI. Did you remember to install @material-ui/core?');
        }
    }
};
export default materialUiPlugin;
